module.exports = __webpack_public_path__ + "static/img/live_wechat02.d3be4a0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/live_wechat02.png
// module id = NkOJ
// module chunks = 1